__turbopack_context__.v({
  "body": "PlaygroundIndexForm-module__a5vOXG__body",
  "bottomButtonBar": "PlaygroundIndexForm-module__a5vOXG__bottomButtonBar",
  "content": "PlaygroundIndexForm-module__a5vOXG__content",
  "contentAndCta": "PlaygroundIndexForm-module__a5vOXG__contentAndCta",
  "heading": "PlaygroundIndexForm-module__a5vOXG__heading",
  "moduleVariant": "PlaygroundIndexForm-module__a5vOXG__moduleVariant",
});
